import React, { lazy } from "react";
import { Redirect } from "react-router-dom";
import HomeLayout from "./Layouts/HomeLayout";
import DashboardLayout from "./Layouts/DashboardLayout";
import InvestmentDashboardLayout from "./Layouts/InvestmentDashboardLayout";
import ProfileLayout from "./Layouts/profileLayout";
export const routes = [

  {
    exact: true,
    path: "/",
    layout: HomeLayout,
    component: lazy(() => import("./View/Pages/IntroPages/Home")),
  },

  {
    exact: true,
    path: "/blogs",
    layout: HomeLayout,
    component: lazy(() => import("./View/Pages/Blogs/Index")),
  },
    {
    exact: true,
    path: "/wealth-plan",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investment/wealth-plan/index")),
  },
  {
    exact: true,
    path: "/most-nris-miss-out-on-this-simple-eduction",
    layout: HomeLayout,
    component: lazy(() => import("./View/Pages/Blogs/blog1/index")),
  },
  {
    exact: true,
    path: "/from-₹0-refund-to-₹48,500",
    layout: HomeLayout,
    component: lazy(() => import("./View/Pages/Blogs/blog2/index")),
  },
  {
    exact: true,
    path: "/indian-mutual-funds-could-be-taxed-differently",
    layout: HomeLayout,
    component: lazy(() => import("./View/Pages/Blogs/blog3/index")),
  },
  {
    exact: true,
    path: "/3-tax-loopholes",
    layout: HomeLayout,
    component: lazy(() => import("./View/Pages/Blogs/blog4/index")),
  },
  {
    exact: true,
    path: "/he-moved-to-dubai-and-stopped-filing-itr",
    layout: HomeLayout,
    component: lazy(() => import("./View/Pages/Blogs/blog5/index")),
  },
  {
    exact: true,
    path: "/where-an-nris-invest-in-mutual-fundsin-india",
    layout: HomeLayout,
    component: lazy(() => import("./View/Pages/Blogs/blog6/index")),
  },
  {
    exact: true,
    path: "/top-mistakes-nris-make-while-investing-in-india",
    layout: HomeLayout,
    component: lazy(() => import("./View/Pages/Blogs/blog7/index")),
  },
  {
    exact: true,
    path: "/equity-vs-debt-funds-what-should-nris-choose",
    layout: HomeLayout,
    component: lazy(() => import("./View/Pages/Blogs/blog8/index")),
  },
  {
    exact: true,
    path: "/is-pan-card-mandatory-for-nri-mutual-fund-investments",
    layout: HomeLayout,
    component: lazy(() => import("./View/Pages/Blogs/blog9/index")),
  },
  {
    exact: true,
    path: "/how-one-nri-reclaimed-₹1.2-lakh-in-taxes",
    layout: HomeLayout,
    component: lazy(() => import("./View/Pages/Blogs/blog10/index")),
  },
  {
    exact: true,
    path: "/where-can-nris-invest-in-mutual-funds-in-india",
    layout: HomeLayout,
    component: lazy(() => import("./View/Pages/Blogs/blog11/index")),
  },
  {
    exact: true,
    path: "/what-happens-to-your-mutual-funds-if-you-become-an-nri",
    layout: HomeLayout,
    component: lazy(() => import("./View/Pages/Blogs/blog12/index")),
  },
  {
    exact: true,
    path: "/how-nris-can-avoid-double-taxation-on-mutual-fund-returns",
    layout: HomeLayout,
    component: lazy(() => import("./View/Pages/Blogs/blog13/index")),
  },
  {
    exact: true,
    path: "/nri-in-the-us-heres-how-the-irs-and-india-are-teaming-up-on-your-finances",
    layout: HomeLayout,
    component: lazy(() => import("./View/Pages/Blogs/blog14/index")),
  },
  {
    exact: true,
    path: "/is-your-ca-missing-these-3-crucial-nri-deductions",
    layout: HomeLayout,
    component: lazy(() => import("./View/Pages/Blogs/blog15/index")),
  },
  {
    exact: true,
    path: "/the-nri-guide-to-indian-regulatory-work",
    layout: HomeLayout,
    component: lazy(() => import("./View/Pages/Blogs/blog16/index")),
  },
  {
    exact: true,
    path: "/is-aadhaar-mandatory-for-nris-in-the-usa-to-invest-in-indian-mutual-funds",
    layout: HomeLayout,
    component: lazy(() => import("./View/Pages/Blogs/blog17/index")),
  },
  {
    exact: true,
    path: "/can-usa-nris-invest-in-all-available-mutual-funds",
    layout: HomeLayout,
    component: lazy(() => import("./View/Pages/Blogs/blog18/index")),
  },
  {
    exact: true,
    path: "/new-income-tax-updates-for-nris-filing-itr-in-india-fy-2024-25",
    layout: HomeLayout,
    component: lazy(() => import("./View/Pages/Blogs/blog19/index")),
  },
  {
    exact: true,
    path: "/mutual-funds",
    layout: HomeLayout,
    component: lazy(() => import("./View/Pages/IntroPages/Invest_mutual_fund/index")),
  },
  {
    exact: true,
    path: "/demat-account",
    layout: HomeLayout,
    component: lazy(() => import("./View/Pages/IntroPages/invest_demat_account")),
  },
  {
    exact: true,
    path: "/bonds-fds",
    layout: HomeLayout,
    component: lazy(() => import("./View/Pages/IntroPages/invest_bonds_fds")),
  },
  {
    exact: true,
    path: "/government-bonds",
    layout: HomeLayout,
    component: lazy(() => import("./View/Pages/IntroPages/governmentBonds")),
  },
  {
    exact: true,
    path: "/corporate-bonds",
    layout: HomeLayout,
    component: lazy(() => import("./View/Pages/IntroPages/corporateBonds")),
  },
  {
    exact: true,
    path: "/why-india",
    layout: HomeLayout,
    component: lazy(() => import("./View/Pages/IntroPages/whyIndia")),
  },
  {
    exact: true,
    path: "/invest-fd",
    layout: HomeLayout,
    component: lazy(() => import("./View/Pages/IntroPages/investFd")),
  },
  {
    exact: true,
    path: "/recovery",
    layout: HomeLayout,
    component: lazy(() => import("./View/Pages/IntroPages/recovery")),
  },
  {
    exact: true,
    path: "/taxation",
    layout: HomeLayout,
    component: lazy(() => import("./View/Pages/IntroPages/taxation")),
  },
  {
    exact: true,
    path: "/about",
    layout: HomeLayout,
    component: lazy(() => import("./View/Pages/IntroPages/about/index")),
  },
  {
    exact: true,
    path: "/invest",
    layout: HomeLayout,
    component: lazy(() => import("./View/Pages/IntroPages/invest")),
  },
  {
    exact: true,
    path: "/kyc-home",
    layout: HomeLayout,
    component: lazy(() => import("./View/Pages/IntroPages/kyc")),
  },
  {
    exact: true,
    path: "/pancard",
    layout: HomeLayout,
    component: lazy(() => import("./View/Pages/IntroPages/panCard")),
  },
  {
    exact: true,
    path: "/banking",
    layout: HomeLayout,
    component: lazy(() => import("./View/Pages/IntroPages/banking")),
  },
  {
    exact: true,
    path: "/lic-policy",
    layout: HomeLayout,
    component: lazy(() => import("./View/Pages/IntroPages/licPolicy")),
  },
  {
    exact: true,
    path: "/dashboard",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/dashboard")),
  },
  {
    exact: true,
    path: "/kyc",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/kyc")),
  },
  // {
  //   exact: true,
  //   path: "/dashboard-taxation",
  //   layout: DashboardLayout,
  //   // guard:true,
  //   component: lazy(() => import("./View/Pages/bookMeeting")),
  // },
  {
    exact: true,
    path: "/dashboard-taxation",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/taxation")),
  },
  // {
  //   exact: true,
  //   path: "/profile",
  //   layout: DashboardLayout,
  //   // guard:true,
  //   component: lazy(() => import("./View/Pages/editProfile")),
  // },
  {
    exact: true,
    path: "/profile",
    layout: ProfileLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/profile/index")),
  },
  {
    exact: true,
    path: "/profile-banking",
    layout: ProfileLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/profile/banking/index")),
  },
  {
    exact: true,
    path: "/profile-nominee",
    layout: ProfileLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/profile/nominee/index")),
  },
  {
    exact: true,
    path: "/invest-dashboard",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/bookMeeting")),
  },
  {
    exact: true,
    path: "/wealth-plan",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investment/wealth-plan/index")),
  },
  {
    exact: true,
    path: "/investment-kyc-status",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investment/kyc-status")),
  },
  {
    exact: true,
    path: "/investment-dashboard",
    layout: InvestmentDashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investment/investment-dashboard/components/Orders")),
  },
  {
    exact: true,
    path: "/identity-verification",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investment/identity-verification")),
  },
  {
    exact: true,
    path: "/create-user",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investment/create-user")),
  },
  {
    exact: true,
    path: "/personal-details",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investment/personal-details")),
  },
  {
    exact: true,
    path: "/more-personal-details",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investment/more-personal-details")),
  },
  {
    exact: true,
    path: "/address",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investment/address")),
  },
  {
    exact: true,
    path: "/tin",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investment/tin")),
  },
  {
    exact: true,
    path: "/upload-signature",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investment/upload_signature")),
  },
  {
    exact: true,
    path: "/add-bank",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investment/addBank")),
  },
  {
    exact: true,
    path: "/bank-account-verification",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investment/bank-account-verification")),
  },
  {
    exact: true,
    path: "/nominee-form",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investment/nominee-form")),
  },
  {
    exact: true,
    path: "/nominee-verification",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investment/nominee-verification")),
  },
  {
    exact: true,
    path: "/funds",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investment/funds")),
  },
  {
    exact: true,
    path: "/place-order-lumpsum",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investment/place-order-lumpsum")),
  },
  {
    exact: true,
    path: "/place-order-sip",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investment/place-order-sip")),
  },
  {
    exact: true,
    path: "/fund-detail/:id",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investment/fund-detail")),
  },
  {
    exact: true,
    path: "/investment-sip/:selected_fund_id/:investor_type",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investment/invest-sip")),
  },
  {
    exact: true,
    path: "/investment-lumpsum/:selected_fund_id/:investor_type",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investment/invest-lumpsum")),
  },
  {
    exact: true,
    path: "/list-bank",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investment/list-bank")),
  },
  {
    exact: true,
    path: "/investment-otp",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investment/investment-otp")),
  },
  {
    exact: true,
    path: "/investment-portfolio",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investment/investment-portfolio")),
  },
   {
    exact: true,
    path: "/portfolio-analysis",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investment/portfolio-analysis/index")),
  },
  {
    exact: true,
    path: "/investment-detail-sip/:id",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investment/sip-detail")),
  },
  {
    exact: true,
    path: "/redeem/:id/:folio",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investment/redeem")),
  },
  {
    exact: true,
    path: "/switch/:id/:folio",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investment/switch")),
  },
  {
    exact: true,
    path: "/stp/:id/:folio",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investment/stp")),
  },
  {
    exact: true,
    path: "/invest-more/:id/:folio",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investment/invest-more")),
  },
  {
    exact: true,
    path: "/swp/:id/:folio",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investment/swp")),
  },
  {
    exact: true,
    path: "/cancel-sip",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investment/sip-detail/cancel-sip")),
  },
  {
    exact: true,
    path: "/redeem-sip",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investment/sip-detail/redeem-sip")),
  },
  {
    exact: true,
    path: "/investment-dashboard/orders",
    layout: InvestmentDashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investment/investment-dashboard/components/Orders")),
  },
  {
    exact: true,
    path: "/investment-dashboard/sips",
    layout: InvestmentDashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investment/investment-dashboard/components/SipsOrder")),
  },
  {
    exact: true,
    path: "/investment-dashboard/swps",
    layout: InvestmentDashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investment/investment-dashboard/components/Swps")),
  },
  {
    exact: true,
    path: "/investment-dashboard/stps",
    layout: InvestmentDashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investment/investment-dashboard/components/Stps")),
  },
  {
    exact: true,
    path: "/bank-accounts",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investment/bank-account/index")),
  },
  {
    exact: true,
    path: "/bank-mandates",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investment/bank-mandate/index")),
  },
  {
    exact: true,
    path: "/nominees",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investment/nominees/index")),
  },
  {
    exact: true,
    path: "/Rewards",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/contact")),
  },
  {
    exact: true,
    path: "/book-meeting",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/bookMeeting")),
  },
  {
    exact: true,
    path: "/free-meeting",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/bookMeeting")),
  },
  {
    exact: true,
    path: "/user-management",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/userManagement")),
  },
  {
    exact: true,
    path: "/kyc-management",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/kycManagement")),
  },
  {
    exact: true,
    path: "/referral-management",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/referralManagement")),
  },
  {
    exact: true,
    path: "/meeting-management",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/MeetingManagement/index")),
  },
  {
    exact: true,
    path: "/rta-feed-management",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/rtaManagement")),
  },
  {
    exact: true,
    path: "/meeting-details",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/MeetingManagement/detail")),
  },
  {
    exact: true,
    path: "/add-minutes-of-meetings",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/MeetingManagement/addMOM")),
  },
  {
    exact: true,
    path: "/user-details",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/userDetails")),
  },
  {
    exact: true,
    path: "/terms&condition",
    layout: HomeLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/static/terms")),
  },
  {
    exact: true,
    path: "/privacy-policy",
    layout: HomeLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/static/privacy")),
  },
  {
    exact: true,
    path: "/aadhar",
    layout: HomeLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/IntroPages/aadhar")),
  },
  {
    exact: true,
    path: "/company-incorporation",
    layout: HomeLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/IntroPages/incorporation")),
  },
  {
    exact: true,
    path: "/regulatory",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/regulatory")),
  },
  {
    exact: true,
    path: "/upload-document",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/mom")),
  },
  {
    exact: true,
    path: "/invest-management",
    layout: DashboardLayout,
    // guard:true,
    component: lazy(() => import("./View/Pages/investManagement/index.js")),
  },
  // {
  //   exact: true,
  //   path: "/login",
  //   layout:"",
  //   component: lazy(() => import("./View/Auth")),
  // },

  {
    exact: true,
    path: "/404",
    component: lazy(() => import("./View/Error/notFound")),
  },
  {
    component: () => <Redirect to="/404" />,
  },
];


